import { getCategoryIconFallbackForSlug, resolveCategoryIconFromApi, } from '../config/categoryIconRegistry';
const categoryIconById = new Map();
const categoryIconByProductId = new Map();
const categoryColorById = new Map();
const categoryColorByProductId = new Map();
const rememberColor = (key, color, map) => {
    const k = (key || '').trim();
    const c = (color || '').trim();
    if (k && c)
        map.set(k, c);
};
export function updateCategoryIconCache(categories) {
    categoryIconById.clear();
    categoryIconByProductId.clear();
    categoryColorById.clear();
    categoryColorByProductId.clear();
    for (const category of categories) {
        if (category.id) {
            categoryIconById.set(category.id, category.icon);
            rememberColor(category.id, category.color, categoryColorById);
        }
        if (category.name) {
            categoryIconById.set(category.name, category.icon);
            rememberColor(category.name, category.color, categoryColorById);
        }
        for (const item of category.items || []) {
            const productId = item.id || item._id;
            if (productId) {
                categoryIconByProductId.set(productId, category.icon);
                rememberColor(productId, category.color, categoryColorByProductId);
            }
        }
    }
}
function readCachedCategoryIcon(product) {
    if (product.categoryIcon) {
        return product.categoryIcon;
    }
    const productId = product.id || product._id;
    if (productId && categoryIconByProductId.has(productId)) {
        return categoryIconByProductId.get(productId) || null;
    }
    const rawCategory = product.category;
    if (typeof rawCategory === 'string' && categoryIconById.has(rawCategory)) {
        return categoryIconById.get(rawCategory) || null;
    }
    return null;
}
export function resolveProductCategoryIcon(product) {
    const cached = readCachedCategoryIcon(product);
    if (cached) {
        return cached;
    }
    if (typeof product.category === 'object' && product.category !== null) {
        const category = product.category;
        return resolveCategoryIconFromApi(category.icon, category.slug || category.name);
    }
    if (product.categorySlug) {
        return getCategoryIconFallbackForSlug(product.categorySlug);
    }
    if (product.categoryName) {
        const slug = product.categoryName.toLowerCase().replace(/\s+/g, '-');
        return getCategoryIconFallbackForSlug(slug);
    }
    if (typeof product.category === 'string' && product.category) {
        return getCategoryIconFallbackForSlug(product.category);
    }
    return getCategoryIconFallbackForSlug(null);
}
/**
 * Löst die im Portal hinterlegte Kategorie-FARBE eines Produkts auf (für die
 * Einfärbung des Kategorie-Icons neben dem Produkt). Liefert `null`, wenn keine
 * Farbe hinterlegt ist – Aufrufer fallen dann auf ihre Default-Farbe zurück.
 */
export function resolveProductCategoryColor(product) {
    const direct = (product.categoryColor || '').trim();
    if (direct)
        return direct;
    const productId = product.id || product._id;
    if (productId && categoryColorByProductId.has(productId)) {
        return categoryColorByProductId.get(productId) || null;
    }
    if (typeof product.category === 'object' && product.category !== null) {
        const color = (product.category.color || '').trim();
        if (color)
            return color;
    }
    const rawCategory = product.category;
    if (typeof rawCategory === 'string' && categoryColorById.has(rawCategory)) {
        return categoryColorById.get(rawCategory) || null;
    }
    if (product.categoryName && categoryColorById.has(product.categoryName)) {
        return categoryColorById.get(product.categoryName) || null;
    }
    return null;
}
export function resolveMenuItemCategoryIcon(menuItem) {
    return resolveProductCategoryIcon(menuItem);
}
export function resolveMenuItemCategoryColor(menuItem) {
    return resolveProductCategoryColor(menuItem);
}
